import React, { useState } from 'react';
import { ExternalLink, X } from 'lucide-react';
const projects = [{
  id: 1,
  title: 'The Botanical Gallery',
  category: 'Floristería Boutique',
  image: 'https://cdn.magicpatterns.com/uploads/gLnDeEkLNPW777LrCQ8vtb/botanical.png',
  link: 'https://botanical.krove.lat/',
  description: 'Diseñamos una landing page elegante y sofisticada para The Botanical Gallery, una floristería boutique especializada en arreglos florales de alta gama. El diseño incorpora una paleta de colores naturales con toques de verde esmeralda y dorado, reflejando la exclusividad de sus productos. Implementamos una galería visual impactante que destaca la belleza de cada arreglo floral, con secciones dedicadas a colecciones estacionales, servicios personalizados y un sistema de reservas integrado.',
  testimonial: '"Krove Latam capturó perfectamente la esencia de mi negocio. La página web refleja la elegancia y calidad que ofrezco a mis clientes. Desde el lanzamiento, he recibido un 40% más de consultas y mis ventas online han crecido significativamente. El proceso fue increíblemente profesional y el resultado superó todas mis expectativas." - María Elena, Propietaria'
}, {
  id: 2,
  title: 'Onyx & Steel',
  category: 'Barbería Premium',
  image: 'https://cdn.magicpatterns.com/uploads/mzSQigFE3WUzW8K4HUJ17X/onyx.png',
  link: 'https://onyx.krove.lat/',
  description: 'Creamos una presencia digital masculina y sofisticada para Onyx & Steel, una barbería premium que combina tradición y lujo. El diseño utiliza una paleta oscura con acentos dorados, evocando exclusividad y profesionalismo. Incluimos un sistema de reservas en línea, galería de estilos de corte, presentación del equipo de barberos expertos, y una sección de productos de cuidado masculino. La página proyecta la experiencia premium que los clientes reciben en el establecimiento.',
  testimonial: '"La landing page que Krove Latam diseñó para mi barbería es simplemente espectacular. Mis clientes constantemente me felicitan por lo profesional que se ve mi negocio online. Las reservas por la web han aumentado un 60% y ahora atraigo clientes de toda la ciudad que nos encuentran en Google. Definitivamente valió cada centavo de la inversión." - Carlos Rodríguez, Fundador'
}, {
  id: 3,
  title: 'Gloss & Chrome Lab',
  category: 'Spa de Uñas',
  image: 'https://cdn.magicpatterns.com/uploads/w4wYBujGNR3EomssiMSAtc/gloss.png',
  link: 'https://glossnails.krove.lat/',
  description: 'Desarrollamos una landing page futurista y vanguardista para Gloss & Chrome Lab, un spa de uñas que se especializa en diseños de alta tecnología y tendencias de moda. El diseño incorpora elementos holográficos, gradientes vibrantes y una estética cyber-chic que refleja la innovación del negocio. Incluimos una galería interactiva de diseños, sistema de citas online, catálogo de servicios con precios transparentes, y una sección de tendencias actuales en nail art.',
  testimonial: '"¡Wow! Krove Latam entendió perfectamente mi visión de un spa de uñas moderno y tecnológico. La página web es una obra de arte que refleja exactamente el nivel de creatividad que ofrezco a mis clientas. He notado que las clientas nuevas llegan más informadas sobre mis servicios y el 70% de mis citas ahora se reservan a través de la web. ¡Increíble trabajo!" - Valentina Sánchez, Directora Creativa'
}, {
  id: 4,
  title: 'PinzColors',
  category: 'Spa de Uñas',
  image: 'https://cdn.magicpatterns.com/uploads/i4yDmMnoXsuUJZevhSj2Xy/Pinzcolors.png',
  link: 'https://pinzcolors.krove.lat/',
  description: 'Diseñamos una landing page femenina y elegante para PinzColors, un spa de uñas premium que combina arte, precisión y durabilidad. El diseño utiliza una paleta suave en tonos lila y rosa, transmitiendo cuidado y sofisticación. Incluimos secciones de servicios, catálogo, historia de la marca, ubicación y un sistema de reservas integrado vía WhatsApp para facilitar las citas.',
  testimonial: '"Mi marca ahora se ve tan profesional como el servicio que ofrezco. Krove Latam entendió mi estilo desde el primer día y mis clientas reservan más fácil que nunca." - Andrea, Fundadora de PinzColors'
}, {
  id: 5,
  title: 'Kit De Ventas',
  category: 'Página de Aterrizaje',
  image: 'https://cdn.magicpatterns.com/uploads/g9B3sVAgRmf55xkgxqcKSY/Kit.png',
  link: 'https://kit.krove.lat/',
  description: 'Creamos una landing page de alta conversión para Kit de Supervivencia: Ventas por DM, un infoproducto digital orientado a micro-emprendedoras. El diseño usa una estética moderna y directa con un copy enfocado en beneficios claros, prueba social y un CTA potente. La página está optimizada para conversión con un flujo simple: titular, beneficios, oferta y pago.',
  testimonial: '"La página convirtió desde el primer día. Krove Latam no solo diseñó, sino que entendió cómo vender mi producto digital. Recomendado 100%." - Cliente Kit de Ventas'
}];
export function WorkGallery() {
  const [selectedProject, setSelectedProject] = useState<(typeof projects)[0] | null>(null);
  return <section id="servicios" className="py-24 px-6 bg-background relative" data-id="element-298">
      <div className="max-w-7xl mx-auto" data-id="element-299">
        <div className="text-center mb-16" data-id="element-300">
          <h2 className="text-sm font-bold tracking-[0.3em] text-primary uppercase mb-4" data-id="element-301">
            Nuestro Trabajo
          </h2>
          <p className="text-3xl md:text-4xl font-serif text-white" data-id="element-302">
            Diseños que proyectan{' '}
            <span className="italic text-text-secondary" data-id="element-303">profesionalismo</span>
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-304">
          {projects.map(project => <div key={project.id} className="group relative rounded-2xl overflow-hidden glass-panel transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_20px_40px_rgba(77,111,255,0.2)]" data-id="element-305">
              {/* Mockup Container */}
              <div className="p-4 bg-white/5 border-b border-white/5" data-id="element-306">
                <div className="flex gap-1.5 mb-3" data-id="element-307">
                  <div className="w-2.5 h-2.5 rounded-full bg-red-500/50" data-id="element-308"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-yellow-500/50" data-id="element-309"></div>
                  <div className="w-2.5 h-2.5 rounded-full bg-green-500/50" data-id="element-310"></div>
                </div>
                <div className="relative aspect-[16/10] overflow-hidden rounded-lg" data-id="element-311">
                  <img src={project.image} alt={`Proyecto ${project.title}`} className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105" data-id="element-312" />
                  <div className="absolute inset-0 bg-background/60 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center" data-id="element-313">
                    <a href={project.link} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-white font-medium bg-white/10 backdrop-blur-md px-4 py-2 rounded-full border border-white/20 hover:bg-white/20 transition-colors" data-id="element-314">
                      Ver detalle <ExternalLink className="w-4 h-4" data-id="element-315" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="p-6" data-id="element-316">
                <h3 className="text-xl font-serif font-medium text-white mb-1" data-id="element-317">
                  {project.title}
                </h3>
                <p className="text-text-secondary text-sm" data-id="element-318">
                  {project.category}
                </p>
              </div>
            </div>)}
        </div>
      </div>

      {/* Modal */}
      {selectedProject && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-fadeIn" data-id="element-319">
          <div className="relative max-w-4xl w-full max-h-[90vh] overflow-y-auto bg-[#0F111A] rounded-3xl border border-white/10 shadow-2xl" data-id="element-320">
            <button onClick={() => setSelectedProject(null)} className="absolute top-4 right-4 z-10 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 backdrop-blur-md flex items-center justify-center transition-colors border border-white/20" data-id="element-321">
              <X className="w-5 h-5 text-white" data-id="element-322" />
            </button>

            <div className="p-8 md:p-12" data-id="element-323">
              <div className="mb-8" data-id="element-324">
                <span className="inline-block px-3 py-1 rounded-full bg-primary/10 text-primary text-xs font-bold tracking-wider uppercase mb-4 border border-primary/20" data-id="element-325">
                  {selectedProject.category}
                </span>
                <h2 className="text-3xl md:text-4xl font-serif font-bold text-white mb-4" data-id="element-326">
                  {selectedProject.title}
                </h2>
              </div>

              <div className="mb-8 rounded-2xl overflow-hidden border border-white/10" data-id="element-327">
                <img src={selectedProject.image} alt={selectedProject.title} className="w-full h-auto" data-id="element-328" />
              </div>

              <div className="space-y-6" data-id="element-329">
                <div data-id="element-330">
                  <h3 className="text-xl font-semibold text-white mb-3 flex items-center gap-2" data-id="element-331">
                    <span className="w-1 h-6 bg-primary rounded-full" data-id="element-332"></span>
                    Descripción del Proyecto
                  </h3>
                  <p className="text-text-secondary leading-relaxed" data-id="element-333">
                    {selectedProject.description}
                  </p>
                </div>

                <div className="glass-panel p-6 rounded-2xl border-l-4 border-accent-start" data-id="element-334">
                  <h3 className="text-lg font-semibold text-white mb-3" data-id="element-335">
                    Testimonio del Cliente
                  </h3>
                  <p className="text-text-secondary leading-relaxed italic" data-id="element-336">
                    {selectedProject.testimonial}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </section>;
}